import Map from 'components/map/map';
import MapLoading from 'components/map/map-loading/map-loading';
import { ManageNetworkMapViewsQuery } from 'generated/graphql';
import React, { FunctionComponent } from 'react';
import MapMarker from 'components/map/map-marker/map-marker';
import env from 'env';
import { useNavigate } from 'react-router';
import { Tooltip } from 'react-leaflet';
import MapGeoJSON from 'components/map/map-geojson/map-geojson';
import { FeatureCollection } from 'geojson';
import BilikZonesLayer from 'components/map/bilik-zones-layer/bilik-zones-layer';

type ManageNetworkMapView = ManageNetworkMapViewsQuery['proView'][number];

type ManageNetworkMapViewProps = {
  displayMapLoading?: boolean;
  views: ManageNetworkMapView[];
  cityFeatureCollection?: FeatureCollection;
};

const ManageNetworkMapView: FunctionComponent<ManageNetworkMapViewProps> = ({
  displayMapLoading,
  views,
  cityFeatureCollection,
}) => {
  const navigate = useNavigate();

  return (
    <Map
      key={`manage-network-map-${views.length}-${cityFeatureCollection?.features.length}`}
      style={{ height: `1000px` }}
      doubleClickZoom={false}
      fit={true}
      zoom={10}
    >
      <BilikZonesLayer />
      {cityFeatureCollection && (
        <MapGeoJSON
          data={cityFeatureCollection}
          onEachFeature={(feature, layer) => {
            layer.bindTooltip(
              `${feature.properties.name} (${feature.properties.count} pros)`,
            );
          }}
        />
      )}
      {displayMapLoading && <MapLoading />}
      {views.map((view) => {
        const geoCoordinates = view.proPostalAddress?.geoCoordinates;

        if (!geoCoordinates || geoCoordinates.type !== 'Point') {
          return null;
        }

        return (
          <MapMarker
            key={`marker-view-${view.id}`}
            type="image-circle"
            position={geoCoordinates}
            hoverable={true}
            eventHandlers={{
              click: () => {
                navigate({
                  pathname: `/pros/update/${view.id}`,
                });
              },
            }}
            url={
              view.avatarHash
                ? `${env.API_URL}/images/${view.avatarHash}/full/40,40/0/default.png`
                : '/images/anonym.jpg'
            }
          >
            <Tooltip direction="top" offset={[0, -25]} opacity={1}>
              <div>
                <img
                  src={
                    view.avatarHash
                      ? `${env.API_URL}/images/${view.avatarHash}/full/200,200/0/default.png`
                      : '/images/anonym.jpg'
                  }
                  alt={view.avatarHash || 'Anonyme'}
                  style={{
                    width: 200,
                    height: 200,
                    objectFit: 'cover',
                    display: 'block',
                    marginBottom: 8,
                    borderRadius: 0,
                  }}
                />
                <div style={{ fontSize: 15 }}>
                  <div style={{ fontWeight: 'bold' }}>
                    {view.proPresentation?.name}
                  </div>
                  <div style={{ color: '#666', fontStyle: 'italic' }}>
                    {view.bilikZone?.name}
                  </div>
                  <div style={{ color: '#666' }}>
                    {view.proPresentation?.mainTradeNames}
                  </div>
                </div>
              </div>
            </Tooltip>
          </MapMarker>
        );
      })}
    </Map>
  );
};

export default ManageNetworkMapView;
